var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M23.225 9.67767V6.40657C23.225 6.14699 23.0138 5.93604 22.754 5.93604H17.8127C17.5533 5.93604 17.3424 6.14699 17.3424 6.40657V9.31711C17.1335 9.31411 16.9244 9.31181 16.7148 9.3102V6.40657C16.7148 5.80118 17.2075 5.30852 17.8127 5.30852H22.754C23.3594 5.30852 23.8521 5.80118 23.8521 6.40657V9.76758C23.6529 9.73599 23.4438 9.70603 23.225 9.67767Z",
    fill: "#100F0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "M15.3025 9.31304V6.40734C15.3025 6.14776 15.0914 5.93681 14.832 5.93681H9.89067C9.63154 5.93681 9.42013 6.14776 9.42013 6.40734V9.63117C9.2032 9.6563 8.99319 9.68281 8.79262 9.71094V6.40734C8.79262 5.80195 9.28527 5.30929 9.89067 5.30929H14.832C15.4376 5.30929 15.9301 5.80195 15.9301 6.40734V9.30912C15.7207 9.30981 15.5116 9.31096 15.3025 9.31304Z",
    fill: "#100F0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M25.068 10.0822V5.8168C25.068 5.05672 24.4497 4.43842 23.6901 4.43842H8.56196C7.80188 4.43842 7.18403 5.05672 7.18403 5.8168V10.0822C6.85667 10.1606 6.59409 10.242 6.38569 10.3252V5.8168C6.38569 4.61639 7.36178 3.6403 8.56196 3.6403H23.6901C24.89 3.6403 25.8663 4.61639 25.8663 5.8168V10.3252C25.6577 10.242 25.3953 10.1606 25.068 10.0822Z",
    fill: "#100F0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "M5.91859 13.4856V11.9115C5.91859 10.0439 26.3334 10.0439 26.3334 11.9115V13.4863C26.3334 12.0817 5.92412 12.0817 5.91859 13.4856Z",
    fill: "#1F2937"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M26.3334 15.4953L26.3331 26.0268V27.0727C26.3331 28.0666 25.4228 28.8907 24.2643 28.9903C24.1871 28.9965 23.3375 29 23.3375 29H8.91374H8.22189H8.22096C6.95555 29 5.91836 28.1327 5.91836 27.0727V26.0268L5.91858 15.4951C5.92204 14.0907 26.3334 14.0909 26.3334 15.4953Z",
    fill: "#6B7280"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.5727649f04b595f5c88ccc816a46665c.svg";
export { ForwardRef as ReactComponent };